import API from '../../clients/api'
import { errorHandler } from '../helpers'

const fetchJWVideo = async id => {
  const route = `/videos/${id}/jw-video?embed=level.videos`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

// eslint-disable-next-line
export { fetchJWVideo }